module.exports = __webpack_public_path__ + "static/media/Queue-amico.869dce6e.png";